var _path, _path2, _path3, _circle, _path4, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.4 198.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "OI_4L_main",
    d: "M59 54.6H37.7v-20c0-5.6 4.8-10.3 10.6-10.3s10.6 4.6 10.6 10.3v20z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "OI_4L_main",
    d: "M74.4 164.3h80.3V34.6c0-5.6-4.8-10.3-10.6-10.3H48M59 54.6v45.3M79.9 43.4H131M105.5 122.2V72.5M79.9 85.3H131M79.9 97.7H131M79.5 110.3h50.4M79.9 56.7H131M90.1 142.4h18"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "OI_4L_main",
    d: "M79.9 110.1V72.5H131v49.7H82.9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "OI_4L_main",
    cx: 125.9,
    cy: 142.2,
    r: 6.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "OI_4L_main",
    d: "M73.9 146.1v28l-15.5-10.4L43 174.1v-28"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "OI_4L_main",
    cx: 58.4,
    cy: 125.9,
    r: 24.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "OI_4L_main",
    cx: 58.4,
    cy: 125.9,
    r: 15.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscription);
export default __webpack_public_path__ + "static/media/subscription.d09e289ccd158bd1bd6f6bd859fa26a4.svg";
export { ForwardRef as ReactComponent };